import { render, staticRenderFns } from "./EMelderComponentMeldenBs10GlobaleAuswahlSkala.vue?vue&type=template&id=fe1c5728"
import script from "./EMelderComponentMeldenBs10GlobaleAuswahlSkala.vue?vue&type=script&lang=js"
export * from "./EMelderComponentMeldenBs10GlobaleAuswahlSkala.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports